import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-10128e98"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "login-password-reset" };
const _hoisted_2 = { class: "login-password-reset__header" };
const _hoisted_3 = { class: "login-password-reset__header-text" };
const _hoisted_4 = { class: "login-password-reset__title" };
const _hoisted_5 = { class: "login-password-reset__subtitle" };
const _hoisted_6 = ["onSubmit"];
const _hoisted_7 = { class: "login-password-reset__form-group" };
const _hoisted_8 = {
    class: "login-password-reset__label",
    for: "password"
};
const _hoisted_9 = { class: "login-password-reset__requirements" };
const _hoisted_10 = ["src"];
const _hoisted_11 = { class: "login-password-reset__form-group" };
const _hoisted_12 = {
    class: "login-password-reset__label",
    for: "confirm-password"
};
const _hoisted_13 = {
    key: 0,
    class: "login-password-reset__confirmation-status"
};
const _hoisted_14 = ["src"];
import LoginFormLogo from '@/components/login/_atoms/LoginFormLogo.vue';
import i18n from '@/i18n';
import { computed, reactive, ref } from 'vue';
import { useToast } from 'vue-toastification';
import { updatePassword } from '../data/updatePassword';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginPasswordReset',
    props: {
        firstToken: { default: '' }
    },
    emits: ['password-updated-success'],
    setup(__props, { emit }) {
        const props = __props;
        const toastOptions = {
            toastClassName: 'login-toaster',
            timeout: 6000,
        };
        const { t } = i18n.global;
        const toast = useToast();
        const loading = ref(false);
        const formData = reactive({ password: '', confirmPassword: '' });
        const noPasswordEntered = computed(() => formData.password.length === 0);
        const hasMinLength = computed(() => formData.password.length >= 10);
        const hasNumber = computed(() => /\d/.test(formData.password));
        const hasLowercase = computed(() => /[a-z]/.test(formData.password));
        const hasUppercase = computed(() => /[A-Z]/.test(formData.password));
        const hasSpecialChar = computed(() => /[^a-zA-Z0-9]/.test(formData.password));
        const requirements = computed(() => [
            { text: t('first-access-password.requirements.min-length'), valid: hasMinLength.value },
            { text: t('first-access-password.requirements.has-number'), valid: hasNumber.value },
            { text: t('first-access-password.requirements.has-lowercase'), valid: hasLowercase.value },
            { text: t('first-access-password.requirements.has-uppercase'), valid: hasUppercase.value },
            { text: t('first-access-password.requirements.has-special-char'), valid: hasSpecialChar.value },
        ]);
        const getIcon = (isValid) => {
            if (noPasswordEntered.value) {
                return 'check-neutral';
            }
            return isValid ? 'check-success' : 'check-error';
        };
        const getRequirementClass = (isValid) => {
            if (noPasswordEntered.value) {
                return '';
            }
            return isValid ? 'login-password-reset__requirement-text--success' : 'login-password-reset__requirement-text--error';
        };
        const validate = async () => {
            if (!isFormValid.value)
                return;
            loading.value = true;
            const response = await updatePassword(formData.password, props.firstToken);
            if (!response.success) {
                loading.value = false;
                toast.error(t('first-access-password.toast.error'), toastOptions);
                return;
            }
            loading.value = false;
            toast.success(t('first-access-password.toast.success-title'), { timeout: 5000 });
            emit('password-updated-success');
        };
        const passwordsMatch = computed(() => formData.password === formData.confirmPassword);
        const isFormValid = computed(() => {
            const allRequirementsMet = hasMinLength.value && hasNumber.value && hasLowercase.value && hasUppercase.value && hasSpecialChar.value;
            const bothFieldsFilled = formData.password.length > 0 && formData.confirmPassword.length > 0;
            return allRequirementsMet && passwordsMatch.value && bothFieldsFilled;
        });
        const confirmPasswordIcon = computed(() => {
            return passwordsMatch.value ? 'check-success' : 'check-error';
        });
        const confirmPasswordMessage = computed(() => {
            return passwordsMatch.value
                ? t('first-access-password.validation.passwords-match')
                : t('first-access-password.validation.passwords-not-match');
        });
        const confirmPasswordClass = computed(() => {
            return passwordsMatch.value
                ? 'login-password-reset__confirmation-text--success'
                : 'login-password-reset__confirmation-text--error';
        });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(LoginFormLogo),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('first-access-password.title')), 1),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('first-access-password.subtitle')), 1)
                    ])
                ]),
                _createElementVNode("form", {
                    class: "login-password-reset__form",
                    onSubmit: _withModifiers(validate, ["prevent"])
                }, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('first-access-password.password-label')), 1),
                        _createVNode(_component_el_input, {
                            id: "password",
                            modelValue: formData.password,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.password) = $event)),
                            type: "password",
                            placeholder: _ctx.$t('first-access-password.password-placeholder'),
                            "show-password": ""
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requirements.value, (requirement, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "login-password-reset__requirement"
                                }, [
                                    _createElementVNode("img", {
                                        class: "login-password-reset__requirement-icon",
                                        src: require(`@/assets/svgs/${getIcon(requirement.valid)}.svg`)
                                    }, null, 8, _hoisted_10),
                                    _createElementVNode("small", {
                                        class: _normalizeClass(["login-password-reset__requirement-text", getRequirementClass(requirement.valid)])
                                    }, _toDisplayString(requirement.text), 3)
                                ]));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('first-access-password.confirm-password-label')), 1),
                        _createVNode(_component_el_input, {
                            id: "confirm-password",
                            modelValue: formData.confirmPassword,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formData.confirmPassword) = $event)),
                            type: "password",
                            placeholder: _ctx.$t('first-access-password.confirm-password-placeholder'),
                            "show-password": "",
                            onPaste: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"])),
                            onCopy: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                            onCut: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["prevent"]))
                        }, null, 8, ["modelValue", "placeholder"]),
                        (formData.confirmPassword)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("img", {
                                    class: "login-password-reset__confirmation-icon",
                                    src: require(`@/assets/svgs/${confirmPasswordIcon.value}.svg`)
                                }, null, 8, _hoisted_14),
                                _createElementVNode("small", {
                                    class: _normalizeClass(['login-password-reset__confirmation-text', confirmPasswordClass.value])
                                }, _toDisplayString(confirmPasswordMessage.value), 3)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_el_button, {
                        class: "login-password-reset__button",
                        "native-type": "submit",
                        disabled: !isFormValid.value,
                        loading: loading.value
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('first-access-password.save-button')), 1)
                        ]),
                        _: 1
                    }, 8, ["disabled", "loading"])
                ], 40, _hoisted_6)
            ]));
        };
    }
});
